import React from 'react';
import PropTypes from 'prop-types';

import ProgressBarWrapper from './ProgressBarWrapper';
import Bar from './Bar';

const ProgressBar = ({ step, total }) => (
  <ProgressBarWrapper>
    <Bar fill={`${(step * 100) / total}%`} />
  </ProgressBarWrapper>
);

ProgressBar.propTypes = {
  step: PropTypes.number,
  total: PropTypes.number,
};

ProgressBar.defaultProps = {
  step: 0,
  total: 1,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./components/ProgressBar/index.js